import { Combobox } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import { Place } from '@th/shared/src/types/Place';
import AiSearchIconWithText from './AiSearchIconWithText';
import isPlace from '@th/shared/src/types/typeGuards/isPlace';
import SvgIcon from '../icons/SvgIcon';

type Props = {
  item: Place | string;
};

export default function PropertySearchComboboxOption({ item }: Props) {
  let icon;
  let label = '';

  if (isPlace(item)) {
    if (item.isArea()) {
      icon = <SvgIcon name={'TbMap'} />;
    } else {
      icon = <SvgIcon name={'TbMapPin'} />;
    }
    label = item.name;
    if (item.contextArea) {
      label = `${label}, ${item.contextArea}`;
    }
  }

  if (typeof item === 'string') {
    icon = <AiSearchIconWithText />;
    label = item;
  }

  return (
    <Combobox.Option
      value={item}
      className={({ active }) =>
        twMerge(
          'flex flex-row items-center',
          'cursor-default select-none px-4 py-2',
          active && 'cursor-pointer bg-lightGray',
        )
      }
    >
      {icon}
      <p className="mb-0 mt-0 ml-2">{label}</p>
    </Combobox.Option>
  );
}
